<template>
    <span>
           <a-button :id="'AttachButton' + _uid" :loading="uploading" type="primary"
                     icon="import">{{ title }}</a-button>
    </span>
</template>
<script>
import { ACCESS_TOKEN } from '@/store/mutation-types'
import plupload from 'plupload'

export default {
  name: 'ExpertUploadSelector',
  props: {
    title: {
      type: String,
      default: '导入数据'
    },
    readonly: {
      type: Boolean,
      required: false,
      default: false
    },
    url: {
      type: String,
      required: true,
      default: false
    },
    max: {
      type: Number,
      required: false
    },
    // 此字段仅用作融合到 Form 检验必须上传功能
    value: {
      type: String
    },
  },
  mounted () {
    this.initUploader()
  },
  created () {
    console.log(this.uploading)
  },
  watch: {},
  data () {
    return {
      uploading: false,
      config: null,
    }
  },
  methods: {
    initUploader () {
      const that = this
      let mimeTypes = []
      const uploader = new plupload.Uploader({
        headers: { 'X-Auth-Token': that.$ls.get(ACCESS_TOKEN) },
        runtimes: 'html5,flash,html4',
        browse_button: 'AttachButton' + that._uid,
        url: that.url,
        flash_swf_url: '../../../static/plupload/2.3.6/Moxie.swf',
        filters: {
          mime_types: [ //只允许上传图片和Xlsx文件
            { title: 'Xlsx files', extensions: 'xlsx,xls' },
          ],
          max_file_size: '20mb', //最大只能上传10mb的文件
          prevent_duplicates: false
        },
        init: {
          PostInit: function () {
            uploader.setOption('multipart_params')
          },
          FilesAdded: function (up, files) {
            if (files.length > that.max) {
              that.$warning({ title: '最多上传 ' + that.max + ' 个文件' })
              uploader.splice(0, up.files.length)
              return
            }
            that.uploading = true
            that.$message.loading('数据正在导入...', 0)
            console.log(up.files.length)
            uploader.start()
          },
          FileUploaded: function (up, file, info) {
            console.log(up)
            console.log(file)
            console.log(info)
            let response = JSON.parse(info.response)
            that.uploading = false
            that.$message.destroy()
            if (response.code !== 200) {
              that.$warning({ title: response.msg })
              that.sendEvent('导入失败')
              // uploader.splice(0, up.files.length) //就算失败了 文件也还在文件列表里面
              return
            }
            that.sendEvent('导入成功')

          },
          UploadComplete: function (up, files) {
            this.uploading = false
          },
          Error: function (up, err) {
            console.log(err)
            if (err.code === -602) {
              that.$message.error('该文件已经上传过！')
            } else {
              that.$message.error(err.message)
            }

          }
        }
      })
      uploader.init()
    },
    sendEvent (msg) {
      this.$emit('success', msg)
    }
  }
}
</script>

<style scoped>
.insertContent {
  position: relative;
}

.insert {
  cursor: default;
  color: #222f3e;
  width: 45px;
  margin: 3px 0;
  position: absolute;
  top: -400px;
  left: 268px;
  height: 34px;
  text-align: center;
  border-radius: 3px;
  line-height: 34px;
}

.insert:hover {
  cursor: default;
  background-color: #dee0e2;
}

.form-input .has-error .ant-btn {
  color: #f5222d;
  border-color: #f5222d;
}
</style>
